import React, { useEffect, useState } from "react";
import Logo from "../../../Images/logo192.png";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getContractById,
  updateContract,
} from "../../../redux/contractSlice/contractSlice";
import notify from "../../../hooks/useNotifaction";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import {
  formatDateArabic,
  formatDateNumbers,
} from "../../../utils/dateFormatter";

export default function Contract({
  contract = {},
  selectedCompany,
  selectedBranch,
  isSingleBranchCompany,
}) {
  const location = useLocation();
  const { ContractId } = useParams();
  const isContractPage =
    location.pathname === `/Contracts/Contract/${ContractId}`;
  const isContractAddPage = location.pathname === `/addContract`;
  const dispatch = useDispatch();
  const { detailsContract } = useSelector((state) => state.contract);

  const [contractDetails, setContractDetails] = useState(null);
  const [isOffer, setIsOffer] = useState(false);

  useEffect(() => {
    if (isContractPage) dispatch(getContractById(ContractId));
  }, [dispatch, isContractPage, ContractId]);

  useEffect(() => {
    if (detailsContract && isContractPage) {
      console.log(detailsContract);
      setContractDetails(detailsContract);
    } else {
      console.log(contract);
      setContractDetails(contract);
    }
  }, [detailsContract, contract]);

  const normalizeDate = (d) => (d ? String(d).slice(0, 10) : "");

  const onInstallmentEdit = async (e) => {
    const { newData, index } = e;

    const original = contractDetails?.payment_installments?.[index];
    if (!original) return;

    try {
      const dataPayload = {};

      const amountChanged = Number(newData.amount) !== Number(original.amount);
      const dueDateChanged =
        normalizeDate(newData.due_date) !== normalizeDate(original.due_date);
      const statusChanged = newData.status !== original.status;
      const paymentDateChanged =
        normalizeDate(newData.payment_date) !==
        normalizeDate(original.payment_date);

      if (amountChanged || dueDateChanged) {
        const installmentUpdate = {
          installment_number: newData.installment_number,
        };

        if (amountChanged) installmentUpdate.amount = Number(newData.amount);
        if (dueDateChanged)
          installmentUpdate.due_date = normalizeDate(newData.due_date);

        dataPayload.installments_update = [installmentUpdate];
      }

      if (statusChanged || paymentDateChanged) {
        const statusUpdate = {
          installment_number: newData.installment_number,
          status: newData.status,
        };

        if (newData.status === "paid") {
          statusUpdate.payment_date =
            normalizeDate(newData.payment_date) ||
            new Date().toISOString().slice(0, 10);
        } else {
          statusUpdate.payment_date = null;
        }

        dataPayload.payment_status_update = statusUpdate;
      }

      if (!Object.keys(dataPayload).length) return;

      await dispatch(
        updateContract({ id: ContractId, data: dataPayload }),
      ).unwrap();

      const updated = await dispatch(getContractById(ContractId)).unwrap();
      setContractDetails({ ...updated });

      notify("تم حفظ التعديلات بنجاح", "success");
    } catch (err) {
      notify("الخادم مشغول حاليًا، حاول مرة أخرى", "error");
    }
  };

  const handlePrintContract = () => {
    document.body.classList.remove("offer-print");
    setTimeout(() => window.print(), 100);
  };

  const handlePrintOffer = () => {
    const titleContract = document.querySelector(".title-contract");
    const pageTitle = document.querySelector(".page-title");
    const introLine = document.querySelector(".intro-line");

    const originalTitle = titleContract?.textContent;
    const originalPageTitle = pageTitle?.textContent;

    if (titleContract) titleContract.textContent = "عرض سعر";
    if (pageTitle) pageTitle.textContent = "عرض سعر";
    if (introLine) introLine.style.display = "none";

    setTimeout(() => {
      window.print();

      if (titleContract) titleContract.textContent = originalTitle;
      if (pageTitle) pageTitle.textContent = originalPageTitle;
      if (introLine) introLine.style.display = "";
    }, 100);
  };

  const getFirstPartyName = () => {
    if (contractDetails?.name) return contractDetails.name;

    const isSingleBranch =
      contractDetails?.single_branch_company ?? isSingleBranchCompany;

    const companyName =
      selectedCompany?.label || contractDetails?.branch?.company?.name;

    if (isSingleBranch) {
      return `شركة ${companyName}`;
    }

    const branchName = selectedBranch?.label || contractDetails?.branch?.name;
    return `شركة ${companyName} فرع ${branchName}`;
  };

  // محررات الأعمدة
  const amountEditor = (options) => {
    return (
      <InputText
        type="number"
        value={options.value}
        onChange={(e) => options.editorCallback(e.target.value)}
        className="w-100"
        step="0.01"
        min="0"
      />
    );
  };

  const dueDateEditor = (options) => {
    return (
      <input
        type="date"
        value={options.value || ""}
        onChange={(e) => options.editorCallback(e.target.value)}
        className="form-control w-100"
      />
    );
  };

  const statusEditor = (options) => {
    const statusOptions = [
      { label: "مدفوع", value: "paid" },
      { label: "غير مدفوع", value: "pending" },
    ];

    return (
      <Dropdown
        value={options.value}
        options={statusOptions}
        onChange={(e) => options.editorCallback(e.value)}
        placeholder="اختر الحالة"
        className="w-100"
        panelClassName="custom-dropdown-panel"
      />
    );
  };

  const paymentDateEditor = (options) => {
    const today = new Date().toISOString().split("T")[0];

    return (
      <input
        type="date"
        value={options.value || ""}
        onChange={(e) => options.editorCallback(e.target.value)}
        className="form-control w-100"
        max={today}
      />
    );
  };

  // عرض الحالة
  const statusBodyTemplate = (rowData) => {
    return rowData.status === "paid" ? "مدفوع" : "غير مدفوع";
  };

  const filteredTerms =
    contractDetails?.terms?.filter((term) => term.title !== "main") || [];
  const mainTerms =
    contractDetails?.terms?.filter((term) => term.title === "main") || [];

  return (
    <>
      {/* -------- HEADER FOR PRINT -------- */}
      <div className="print-header d-none d-print-block text-center py-3 mb-3 w-100">
        <div className="logo-print d-flex mb-2 align-items-center justify-content-between">
          <div>
            <h1 className="h6 mb-0 text-center">
              بصمة خبرة لأدوات الأمن والسلامة
            </h1>
            <h1 className="h6 mb-0 text-start">
              Experience Mark For Safety & Security Tools
            </h1>
            <p className="mb-0">
              Supply ,Installation & Maintenance توريد وتركيب وصيانة
            </p>
          </div>
          <figure className="me-5 mb-0 ">
            <img src={Logo} alt="logo" />
          </figure>
        </div>
      </div>

      <div className={isContractPage ? "main" : "container-fluid"}>
        <h1 className="mb-3 text-white print-hide page-title">
          عقد شركة أرامكو للبترول
        </h1>

        <div className="container22">
          <div className="card">
            {isContractPage && (
              <div className="card-header text-end print-hide">
                <button
                  className="btn btn-primary me-2"
                  onClick={handlePrintContract}
                >
                  طباعة عقد
                </button>
                <button className="btn btn-success" onClick={handlePrintOffer}>
                  طباعة عرض سعر
                </button>
              </div>
            )}

            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-12">
                  <div className="print-   py-3 mb-2 d-print-none">
                    <div className="logo d-flex mb-3 align-items-center ">
                      <figure className="me-3 mb-0">
                        <img src={Logo} alt="logo" style={{ height: "70px" }} />
                      </figure>
                      <div>
                        <h1 className="h6 mb-0 text-start">
                          بصمة خبرة لأدوات الأمن والسلامة
                        </h1>
                        <h1 className="h6 mb-0 text-start">
                          Experience Mark For Safety & Security Tools
                        </h1>
                        <p className="mb-0 fs-5 text-start" dir="ltr">
                          Supply ,Installation & Maintenance توريد وتركيب وصيانة
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4  mx-auto text-center">
                  <h4 className="title-contract contract-type-title">
                    عقد صيانة
                  </h4>
                  <h5>{contractDetails?.contract_number}</h5>
                </div>
              </div>

              <div className="">
                <p className="intro-line">
                  تم بعون الله وتوفيقه إبرام هذا {isOffer ? "العرض" : "العقد"}{" "}
                  في {formatDateNumbers(contractDetails?.start_date)} بين كلا من
                  :-
                </p>

                <div className="d-flex justify-content-between">
                  <p>{getFirstPartyName()}</p>
                  {contractDetails?.first_party && (
                    <p>ويمثله {contractDetails?.first_party}</p>
                  )}
                  <p>(يشار اليها فيما يلي بالطرف الأول)</p>
                </div>
                <div className="d-flex justify-content-between">
                  <p>مؤسسة بصمة خبرة لأدوات ومواد السلامة</p>
                  {contractDetails?.second_party && (
                    <p className="personInfo">
                      ويمثله {contractDetails?.second_party}
                    </p>
                  )}
                  <p>(يشار اليها فيما يلي بالطرف الثاني)</p>
                </div>
              </div>

              <div className="">
                <h5>تمهيد</h5>
                <p>{contractDetails?.introduction || "لا يوجد تمهيد."}</p>
              </div>

              {contractDetails?.clauses?.length > 0 && (
                <>
                  <div
                    className="mx-5 col-md-4 col-sm-6 mt-5"
                    style={{ marginTop: "30px" }}
                  >
                    <h5>مفردات الصيانة :</h5>
                  </div>
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th>م</th>
                        <th>البند</th>
                        {contractDetails?.clauses.some(
                          (clause) => clause.quantity !== undefined,
                        ) && <th>الكمية</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {contractDetails?.clauses.length > 0 ? (
                        contractDetails?.clauses.map((clause, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td className="text-start">{clause.item}</td>
                            {contractDetails?.clauses.some(
                              (c) => c.quantity !== undefined,
                            ) && (
                              <td className="text-start">
                                {clause?.quantity || "-"}
                              </td>
                            )}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={
                              contractDetails?.clauses.some(
                                (c) => c.quantity !== undefined,
                              )
                                ? "3"
                                : "2"
                            }
                          >
                            لا توجد بنود حالياً.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </>
              )}

              <div className="row justify-content-between ">
                <div className="col-md-4 col-sm-6">
                  <h5>المدة:</h5>
                  <p>
                    {formatDateNumbers(contractDetails?.start_date)} حتى{" "}
                    {formatDateNumbers(contractDetails?.end_date)}
                  </p>
                </div>
                <div className="col-md-4 col-sm-6">
                  <h5>القيمة:</h5>
                  <p className="mb-0">{contractDetails?.value} ريال سعودي</p>
                  <p>شامل قيمة الضريبة المضافة</p>
                </div>
                <div className="col-md-4 col-sm-6">
                  <h5>عدد الزيارات:</h5>
                  <p>{contractDetails?.maintenance_visits} زيارة</p>
                </div>
                <div className="col-md-4 col-sm-6">
                  <h5>طريقة الدفع:</h5>
                  <p>
                    {contractDetails?.payment_type === "full"
                      ? "نقدي"
                      : "دفعات"}
                  </p>
                </div>
              </div>

              {contractDetails?.payment_type === "installments" &&
                !isContractAddPage &&
                !isOffer && (
                  <>
                    <div className="mx-5 col-md-4 col-sm-6 mt-5 print-hide">
                      <h5>دفعات التقسيط:</h5>
                    </div>
                    <div className="print-hide installments-table-wrapper">
                      <DataTable
                        value={contractDetails.payment_installments || []}
                        editMode="row"
                        onRowEditComplete={onInstallmentEdit}
                        dataKey="installment_number"
                        tableStyle={{ minWidth: "50rem" }}
                        emptyMessage="لا توجد دفعات حالياً"
                      >
                        <Column
                          field="installment_number"
                          header="م"
                          style={{ width: "5%" }}
                        />
                        <Column
                          field="amount"
                          header="المبلغ (ر.س)"
                          editor={amountEditor}
                          style={{ width: "20%" }}
                        />
                        <Column
                          field="due_date"
                          header="تاريخ الاستحقاق"
                          editor={dueDateEditor}
                          style={{ width: "20%" }}
                        />
                        <Column
                          field="status"
                          header="حالة الدفع"
                          body={statusBodyTemplate}
                          editor={statusEditor}
                          style={{ width: "15%" }}
                        />
                        <Column
                          field="payment_date"
                          header="تاريخ الدفع"
                          editor={paymentDateEditor}
                          style={{ width: "20%" }}
                        />
                        <Column
                          rowEditor
                          headerStyle={{ width: "10%", minWidth: "8rem" }}
                          bodyStyle={{ textAlign: "center" }}
                        />
                      </DataTable>
                    </div>
                  </>
                )}

              {contractDetails?.terms?.length > 0 && (
                <div>
                  <h5>بنود العقد:</h5>
                  <ol>
                    {contractDetails?.terms?.length > 0 ? (
                      contractDetails?.terms?.map((term, index) => (
                        <li key={index}>
                          <p>{term.description}</p>
                        </li>
                      ))
                    ) : (
                      <p>لا توجد بنود حالياً.</p>
                    )}
                  </ol>
                </div>
              )}

              <div className="signature-section">
                <div className="row">
                  <div className="col-6 text-center">
                    <p className="h5">الطرف الأول</p>
                    <p>{getFirstPartyName()}</p>
                    <p>التوقيع</p>
                    <p>الختم</p>
                  </div>
                  <div className="col-6 text-center">
                    <p className="h5">الطرف الثاني</p>
                    <p>مؤسسة بصمة خبرة لأدوات الأمن والسلامة</p>
                    <p>التوقيع</p>
                    <p>الختم</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* -------- FIXED FOOTER FOR EVERY PAGE -------- */}
      <div className="print-footer-fixed d-none d-print-block">
        <div className="footer-content">
          <div className="footer-top text-white ">
            <div className="d-flex justify-content-between flex-wrap ">
              <div className="w-50 text-start">
                المركز الرئسى : جدة - حى الفيصلية - شارع يزيد بن معاوية
              </div>
              <div className="w-50 text-end" dir="ltr">
                Head Offce : Jeddah - Al Faisaliyah Dist - Yazid Bin Muawyah ST.
              </div>
            </div>

            <div className="d-flex justify-content-between flex-wrap">
              <div className="w-50 text-start">
                فر ع الرياض : الرياض - حي الخالدية - طريق الخرج{" "}
              </div>
              <div className="w-50 text-end" dir="ltr">
                Riyadh Branch: Riyadh - AL Khalidiyah Dist - Al Kharj Rd.
              </div>
            </div>
            <div className="d-flex justify-content-between flex-wrap">
              <div className="w-50 text-start">
                سجل تجاري : 4030281017 - 4030260098{" "}
              </div>
              <div className="w-50 text-end" dir="ltr">
                C.R: 4030281017 - 4030260098
              </div>
            </div>
          </div>
          <div className="footer-bottom text-white d-flex justify-content-between flex-wrap">
            <div className="footer-item">
              <i className="fa fa-phone"></i> 0531955966
            </div>
            <div className="footer-item">
              <i className="fa fa-phone"></i> 0541344107
            </div>
            <div className="footer-item">
              <i className="fa fa-envelope"></i> ali@experience-mark.com
            </div>
            <div className="footer-item">
              <i className="fa fa-globe"></i> www.experiencemark.com
            </div>
          </div>
        </div>
      </div>

      {/* -------- PRINT CSS -------- */}
      <style>
        {`
  /* تنسيقات جدول الدفعات */
  .installments-table-wrapper .p-datatable {
    border: 1px solid #dee2e6;
    border-radius: 0.375rem;
    overflow: hidden;
  }

  .installments-table-wrapper .p-datatable-thead > tr > th {
    background-color: #f8f9fa;
    color: #212529;
    font-weight: 600;
    padding: 1rem;
    border-bottom: 2px solid #dee2e6;
    text-align: center;
  }

  .installments-table-wrapper .p-datatable-tbody > tr > td {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #dee2e6;
    text-align: center;
    vertical-align: middle;
  }

  .installments-table-wrapper .p-datatable-tbody > tr:hover {
    background-color: #f8f9fa;
  }

  /* تنسيقات الحقول */
  .installments-table-wrapper input[type="number"],
  .installments-table-wrapper input[type="date"],
  .installments-table-wrapper .p-dropdown {
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    background-color: #ffffff !important;
  }

  .installments-table-wrapper input[type="number"]:focus,
  .installments-table-wrapper input[type="date"]:focus,
  .installments-table-wrapper .p-dropdown:focus {
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  }

  .installments-table-wrapper .p-dropdown {
    background: #ffffff !important;
  }

  .installments-table-wrapper .p-dropdown .p-dropdown-label {
    background: #ffffff !important;
    color: #212529 !important;
    padding: 0.5rem;
  }

  .installments-table-wrapper .p-dropdown .p-dropdown-trigger {
    background: #ffffff !important;
    color: #212529 !important;
  }

  /* القائمة المنسدلة */
  .p-dropdown-panel.custom-dropdown-panel {
    background: #ffffff !important;
    border: 1px solid #ced4da !important;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
    z-index: 1050 !important;
  }

  .p-dropdown-panel.custom-dropdown-panel .p-dropdown-items-wrapper {
    background: #ffffff !important;
  }

  .p-dropdown-panel.custom-dropdown-panel .p-dropdown-items {
    background: #ffffff !important;
  }

  .p-dropdown-panel.custom-dropdown-panel .p-dropdown-item {
    padding: 0.5rem 1rem !important;
    background: #ffffff !important;
    color: #212529 !important;
  }

  .p-dropdown-panel.custom-dropdown-panel .p-dropdown-item:hover {
    background-color: #e9ecef !important;
    color: #212529 !important;
  }

  .p-dropdown-panel.custom-dropdown-panel .p-dropdown-item.p-highlight {
    background-color: #0d6efd !important;
    color: #ffffff !important;
  }

  /* أزرار التعديل */
  .installments-table-wrapper .p-row-editor-init,
  .installments-table-wrapper .p-row-editor-save,
  .installments-table-wrapper .p-row-editor-cancel {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    margin: 0 0.25rem;
  }

  .installments-table-wrapper .p-row-editor-init {
    color: #0d6efd;
  }

  .installments-table-wrapper .p-row-editor-save {
    color: #198754;
  }

  .installments-table-wrapper .p-row-editor-cancel {
    color: #dc3545;
  }

  .installments-table-wrapper .p-row-editor-init:hover,
  .installments-table-wrapper .p-row-editor-save:hover,
  .installments-table-wrapper .p-row-editor-cancel:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  @media print {
    @page {
      margin: 0;
      size: A4;
    }

    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    html, body {
      margin: 0 !important;
      padding: 0 !important;
      height: 100% !important;
      overflow: visible !important;
    }

    body {
      padding-top: 0 !important;
      padding-bottom: 140px !important;
    }

    header, footer {
      display: none !important;
    }

    .print-hide {
      display: none !important;
    }

    /* الهيدر المطبوع */
    .print-header {
      display: block !important;
      margin: 0 !important;
      padding: 15px 20px !important;
      border-bottom: 2px solid #0097a7;
      background: white;
    }

    .print-header .logo-print img {
      max-width: 80px;
      height: auto;
    }

    /* المحتوى */
    .main, .container-fluid {
      margin: 0 !important;
      padding: 20px !important;
    }

    .card {
      border: none !important;
      box-shadow: none !important;
    }

    .card-body {
      padding: 20px !important;
    }

    /* الجداول */
    table {
      page-break-inside: auto !important;
      margin-bottom: 20px !important;
    }

    tr {
      break-inside: auto !important;
      page-break-inside: auto !important;
    }

    td, th {
      break-inside: avoid !important;
      page-break-inside: avoid !important;
      padding: 8px !important;
    }

    thead {
      display: table-header-group !important;
    }

    tbody {
      page-break-inside: auto !important;
    }

    /* قسم التوقيعات */
    .signature-section {
      page-break-inside: avoid !important;
      margin-top: 30px !important;
    }

    /* الفوتر الثابت في كل صفحة */
    .print-footer-fixed {
      display: block !important;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 110px;
      background: linear-gradient(to right, #0097a7, #00796b) !important;
      color: white !important;
      font-size: 11px;
      z-index: 9999;
    }

    .footer-content {
      padding: 8px 20px;
    }

    .footer-top {
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      margin-bottom: 6px;
      border-bottom: 1px solid rgba(255,255,255,0.3);
      padding-bottom: 4px;
    }

    .footer-bottom {
      display: flex;
      justify-content: space-around;
      align-items: center;
      gap: 10px;
      font-size: 10px;
    }

    .footer-item {
      display: flex;
      align-items: center;
      gap: 5px;
      color: white !important;
    }

    .footer-item i {
      font-size: 11px;
    }

    body::before,
    body::after {
      display: none !important;
    }
  }

  .print-header {
    display: none;
  }

  .print-footer-fixed {
    display: none;
  }
`}
      </style>
    </>
  );
}
